import { AssetDtoEnhanced, AssetsHashMap, GroupsHashMap } from 'common/types';

import { ChartDataGetter } from 'components/ChartWidget/types';
import { OrderTypeEnum } from 'components/Orders/list/types';

import { DerivativeOrderTypeEnum } from 'views/derivatives/orders/types';
import { OrderAction } from 'views/spot/dashboard/types';

export enum DerivativesTabs {
  ORDER = 'order',
  CHART = 'chart',
  INFO = 'info',
  OPEN_ORDERS = DerivativeOrderTypeEnum.OPEN_ORDERS,
  ORDERS_HISTORY = DerivativeOrderTypeEnum.ORDERS_HISTORY,
  OPEN_POSITIONS = DerivativeOrderTypeEnum.OPEN_POSITIONS,
  POSITIONS_HISTORY = DerivativeOrderTypeEnum.POSITIONS_HISTORY,
  // ASSETS = DerivativeOrderTypeEnum.ASSETS,
}

export type CommonDerivativesAssetProps = {
  asset: AssetDtoEnhanced;
  isFavorite: boolean;
  onFavoriteInteract: (code: string) => void;
  isFullScreenMode?: boolean;
  isLandscape?: boolean;
  onChangeFullScreenMode: (isFullScreen: boolean) => void;
  onTradeDirectionChange: (direction: OrderAction) => void;
  baseCurrencyTotal: number | undefined;
  quotedCurrencyTotal: number | undefined;
  currencyPair: string;
  tradeDirection: OrderAction;
  base: string;
  quoted: string;
  onGetChartData: ChartDataGetter;
};

export interface DerivativesAssetDesktopProps extends CommonDerivativesAssetProps {
  ordersSelectedTab: OrderTypeEnum;
  setOrdersSelectedTab: (tab: OrderTypeEnum) => void;
}

export interface DerivativesDashboardMobileProps extends CommonDerivativesAssetProps {
  ordersSelectedTab: OrderTypeEnum;
  setOrdersSelectedTab: (tab: OrderTypeEnum) => void;
  selectedTab: DerivativesTabs;
  setSelectedTab: (activeTab: DerivativesTabs) => void;
}

export interface DerivativesComponentProps {
  data: AssetsHashMap;
  groups: GroupsHashMap;
  favorites: string[];
  loading: boolean;
  onGenerateLink: (code: string) => string;
  onFavorite: (symbol: string) => void;
  onSubscribe: (code: string) => { unsubscribe: () => void };
}

export enum DerivativeInvokeEnum {
  SUBSCRIBE_DERIVATIVE = 'derivative-price-sub',
  UNSUBSCRIBE_DERIVATIVE = 'derivative-price-unsub',
  RECEIVE_DERIVATIVE_MARK_PRICE = 'derivatives-mark-price-receive',
  RECEIVE_DERIVATIVE_PRICE = 'derivatives-price-receive',
  SUBSCRIBE_DERIVATIVE_ORDER_BOOK = 'derivatives-order-book-subscribe',
  UNSUBSCRIBE_DERIVATIVE_ORDER_BOOK = 'derivatives-order-book-unsubscribe',
  RECEIVE_DERIVATIVE_ORDER_BOOK_SNAPSHOT = 'derivatives-order-book-snapshot',
  RECEIVE_DERIVATIVE_ORDER_BOOK_UPDATE = 'derivatives-order-book-update',
  RECEIVE_DERIVATIVE_ORDER_UPDATED = 'derivatives-order-updated',
  RECEIVE_DERIVATIVE_ORDER_OPENED = 'derivatives-order-opened',
  RECEIVE_DERIVATIVE_ORDER_CLOSED = 'derivatives-order-closed',
  RECEIVE_DERIVATIVE_POSITION_CREATED = 'derivatives-opened-position-created',
  RECEIVE_DERIVATIVE_POSITION_UPDATED = 'derivatives-opened-position-updated',
  RECEIVE_DERIVATIVE_CLOSED_POSITION_CREATED = 'derivatives-closed-position-created',
  RECEIVE_DERIVATIVE_CLOSED_POSITION_UPDATED = 'derivatives-closed-position-updated',
  RECEIVE_DERIVATIVE_POSITION_CLOSED = 'derivatives-opened-position-closed',
}

export type DerivativesConfig = {
  invokeType: DerivativeInvokeEnum;
  hub: string;
  subscribeId: string;
  data: [string[]];
  id: string;
  ref?: string;
  hubEvents?: DerivativeInvokeEnum[];
};

export type DerivativeOrderBookConfig = {
  invokeType: DerivativeInvokeEnum;
  hub: string;
  subscribeId: string;
  data: string[];
  id: string;
  ref?: string;
  hubEvents?: DerivativeInvokeEnum[];
};

export type DerivativeSocketConfigType = DerivativesConfig | DerivativeOrderBookConfig;

export interface DerivativesChartProps {
  symbol: string;
  onGetData: ChartDataGetter;
  onChangeFullScreenMode: CommonDerivativesAssetProps['onChangeFullScreenMode'];
  isFullScreenMode: CommonDerivativesAssetProps['isFullScreenMode'];
  isLandscape: CommonDerivativesAssetProps['isLandscape'];
}

export enum DerivativeInfoTabs {
  ORDERBOOK = 'orderbook',
  STATISTICS = 'statistics',
}
